<template>
  <div class="container">
    <o-bread-crumb>
      <template v-slot:pageName>
        System
      </template>
      <template v-slot:pageDetail>
        Log
      </template>
      <template v-slot:pageDescription>
        <br />
      </template>
    </o-bread-crumb>
    <div class="card text-center">
      <div class="card-header">
        <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
          <li class="nav-item">
            <div class="d-flex d-inline-block">
              <a class="nav-link text-dark fs-4" href="#">Logs of System</a>
            </div>
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="d-flex justify-content-center spinner-border text-primary spinner-position" v-if="page.isLoading">
        </div>
        <div class="spinner" v-if="page.isLoading"></div>
        <div v-if="page.output">
          <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
            <li class="nav-item">
              <div class="d-flex d-inline-block">
                <o-search :searchOptions="searchOptions" @submit="search" @clear="clearSearch"></o-search>
              </div>
            </li>
            <li class="nav-item btn btn-primary btn-sm">
              <button class="reload nav-link text-white" @click.prevent="load_state()">&#x21bb;</button>
            </li>
          </ul>
          <div class="table-responsive">
            <o-table class="table table-hover">
              <thead>
                <tr v-if="fields">
                  <th class="fw-bolder text-muted" scope="col" v-for="(field, index) in fields" :key="index">
                    {{ field }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in systemLogs" :key="index">
                  <td>{{ (meta.page - 1) * meta.limit + index + 1 }}</td>
                  <td>
                    <span v-if="!showUserId[index]">{{ shortenUserId(item.user_id) }}</span>
                    <span v-else>{{ item.user_id }}</span>
                    <button @click="toggleUserId(index)" class="btn btn-link custom-btn">{{ showUserId[index] ? 'Hide' : 'Show' }}</button>
                  </td>
                  <td>{{ item.user_name }}</td>
                  <td>{{ item.component }}</td>
                  <td class="json-viewer">
                    <pre v-if="isExpanded.before[index]" @click="toggle(index, 'before')">{{ formatJson(item.before) }}</pre>
                    <span v-else @click="toggle(index, 'before')">{{ collapsedJson(item.before) }}</span>
                    <button @click="toggle(index, 'before')" class="btn btn-link custom-btn">{{ isExpanded.before[index] ? 'Hide' : 'Show' }}</button>
                  </td>
                  <td class="json-viewer">
                    <pre v-if="isExpanded.after[index]" @click="toggle(index, 'after')">{{ formatJson(item.after) }}</pre>
                    <span v-else @click="toggle(index, 'after')">{{ collapsedJson(item.after) }}</span>
                    <button @click="toggle(index, 'after')" class="btn btn-link custom-btn">{{ isExpanded.after[index] ? 'Hide' : 'Show' }}</button>
                  </td>
                  <td>{{ item.type }}</td>
                  <td>{{ formatDate(item.created_at) }}</td>
                </tr>
              </tbody>
            </o-table>
          </div>
        </div>
      </div>
      <div class="container mt-5">
        <o-pagination :page="meta.page" :total="meta.total" @callback="navPage" />
      </div>
    </div>
  </div>
</template>

<script>
import { OBreadCrumb, OTable, OSearch, OPagination } from '@/components/OmnihControl';
import { mapState } from 'vuex';
import { computed, onMounted, reactive, ref, onBeforeUnmount } from 'vue';
import store from '@/store/';

export default {
  setup() {
    let lastActivePage = 1;

    const page = reactive({
      isLoading: false,
      output: false
    });

    const isExpanded = reactive({
      before: [],
      after: []
    });

    const showUserId = reactive([]);

    let fields = ref([
      'No',
      'User Id',
      'User Name',
      'Component',
      'Before',
      'After',
      'Type',
      'Timestamp'
    ]);

    const systemLogsSearch = ref([]);

    const searchOptions = reactive([
      { value: 'component', text: 'component' },
      { value: 'user_name', text: 'user name' }
    ]);
    const searchBy = reactive({
      selected: ["component", "user name"],
      criteria: "",
    });
    let meta = computed(() => store.state.Systemlog.meta);

    onMounted(() => {
      store.commit('Systemlog/reset_meta');
      
      load_state();
    });

    onBeforeUnmount(() => {
        const updatedMeta = { ...meta.value, page: lastActivePage };
        store.commit('Systemlog/switch_page', { meta: updatedMeta });

        store.commit('Systemlog/clear_search');
        store.dispatch('Systemlog/read').then(() => {});
    });

    function load_state() {
      page.isLoading = true;

      store.dispatch('Systemlog/read')
        .catch(err => console.error(err))
        .finally(() => {
          page.isLoading = false;
          page.output = true;
        });
    }

    function navPage(pageNumber) {
      const updatedMeta = { ...meta.value, page: pageNumber };

      store.commit('Systemlog/switch_page', { meta: updatedMeta });
      load_state();
    }

    function search(searchBy) {
      const { selected, criteria } = searchBy;

      if (selected && criteria) {
        let search = {};
        search[selected] = criteria;

        const updatedMeta = { ...meta.value, page: 1 };
        store.commit('Systemlog/switch_page', { meta: updatedMeta });

        store.commit('Systemlog/set_search', { search });
        store.dispatch('Systemlog/read').then(() => {});
      }
    }

    function clearSearch() {
      const updatedMeta = { ...meta.value, page: lastActivePage };
      store.commit('Systemlog/switch_page', { meta: updatedMeta });

      store.commit('Systemlog/clear_search');
      store.dispatch('Systemlog/read').then(() => {});
    }

    function formatJson(jsonData) {
      if (!jsonData) return '';
      const test = JSON.parse(jsonData);
      return JSON.stringify(test, null, 2);
    }

    function collapsedJson(jsonData) {
      if (!jsonData) return '';
      const test = JSON.parse(jsonData);
      return JSON.stringify(test, null, 2).slice(0, 2) + '...';
    }

    function toggle(index, type) {
      isExpanded[type][index] = !isExpanded[type][index];
    }

    function formatDate(date) {
      const newDate = new Date(date);

      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: 'UTC'
      };

      const datePart = newDate.toLocaleDateString('en-US', options).split(', ');

      const formattedDate = `${datePart[0]} on ${datePart[1]} ${datePart[2]}`;

      return formattedDate;
    }

    function shortenUserId(userId) {
      if (!userId) return '';
      return userId.slice(0, 5) + '...';
    }

    function toggleUserId(index) {
      showUserId[index] = !showUserId[index];
    }

    return {
      page,
      searchOptions,
      searchBy,
      meta,
      fields,
      load_state,
      navPage,
      search,
      clearSearch,
      systemLogsSearch,
      formatJson,
      formatDate,
      toggle,
      isExpanded,
      collapsedJson,
      shortenUserId,
      showUserId,
      toggleUserId
    };
  },
  computed: {
    ...mapState({
      systemLogs: state => state.Systemlog.systemLogs,
      searchBy: state => state.OSearch
    }),
  },
  components: {
    OTable,
    OPagination,
    OBreadCrumb,
    OSearch,
  }
};
</script>

<style scoped>
.container {
  overflow-x: auto;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.table {
  width: 100%;
  table-layout: fixed;
}

.table th,
.table td {
  word-wrap: break-word;
  white-space: normal;
}

.form-group {
  width: 250px;
  text-align: left;
  padding-left: 16px;
}

.json-viewer pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  cursor: pointer;
  color: black;
}

.json-viewer span {
  cursor: pointer;
  color: black;
}

.json-viewer button {
  margin-left: 10px;
  cursor: pointer;
  background: none;
  border: none;
}

.custom-btn {
  text-decoration: none;
  padding: 0;
  color: #cb5b5b;
}

.btn-link:hover {
  color: black;
}
</style>